import { INavItem } from '../interfaces/nav-item';

export let menu: INavItem[] = [
  // {
  //   displayName: 'Dashboard',
  //   iconName: 'dashboard',
  //   route: 'disbursements/dashboard'
  // },
  {
    displayName: 'Create Disbursement',
    iconName: 'paid',
    route: 'disbursements/dsb-inv',
    children: [
    ],
  },
  // {
  //   displayName: 'Account Lookup',
  //   iconName: 'business',
  //   route: 'disbursements/acct',
  // },
  {
    displayName: 'Disbursement Status',
    iconName: 'assignment',
    route: 'disbursements/dsb-ocr'
  },
  // {
  //   displayName: 'Activities',
  //   iconName: 'grading',
  //   route: 'disbursements/activities',
  // },
  {
    displayName: 'My Account',
    iconName: 'person',
    route: 'disbursements/my-acct'
  },
  {
      displayName: 'Sign Out',
      iconName: 'highlight_off',
      route: ''
  }
];